<template lang="pug">
  div.event-list
    input.form-control(type="text" v-model="searchText" placeholder="輸入藥物名稱以搜尋事件" ref="input")
    div.upper-subpanel--inside(v-if="events.length === 0")
      Loader(v-if="fetchStatus === 'start'")
      h3(v-if="fetchStatus === 'done'") 無事件紀錄
    div.drug-search-list(v-else style="height: 91%")
      div(
        :class="{'btn': true, 'drug-button': true, 'drug-selected': item.selected, 'returned-schedule': (number2 && item.checked) }" 
        v-for="item in events"
        @click="selectEvent(item.id)"
      )
        div.drug-head
          div.drug-head-icon-wrap
            font-awesome-layers(class="fa-lg")
              font-awesome-icon(:icon="circleIcon" size="lg" color="yellowgreen")
              font-awesome-icon(:icon="noteMedicalIcon" transform="shrink-6 right-2" color="white")
            
          div.drug-head--content
            
            span(v-if="item.medication.CGMH_number !== null") [ {{item.medication.CGMH_number }} - 
              span {{ item.medication.code }} ]
            span {{item.medication.generic_name}}
            span 
              small {{ item.event_type.event_name_zh }}事件
        div.drug-item
          div.info-col
            div.info-col-head
              span 使用者
            div.info-col-content
              //- p(v-if="item.employee.last_name") {{ item.employee.last_name }}{{ item.employee.first_name }}
              p {{item.employee_name}}
          div.info-col(style="width: 50px")
            div.info-col-head
              span 數量
            div.info-col-content
              p {{ item.number1 }}
          div.info-col
            div.info-col-head
              span 病歷號
            div.info-col-content
              p(v-if="item.med_record_no === '' || item.med_record_no === undefined || item.med_record_no === null") 未設定
              p(v-else) {{ item.med_record_no }}
          div.info-col
            div.info-col-head
              span 批號
            div.info-col-content(v-if="item.drug_storage")
              p(v-if="item.batch_no === '' || item.batch_no === undefined || item.batch_no === null") 未設定
              p(v-else) {{ item.batch_no }}
          div.info-col(style="width: 130px")
            div.info-col-head
              span 時間
            div.info-col-content
              p {{ item.record_time | readableTime }}
          div.info-col
            div.label-badge.restrained-badge(v-if="item.medication.restrained_class > 0")
              span 管制藥
            div.label-badge(v-if="item.event_type.event_name === 'FETCH' && item.related_events.length === 0" :class="{ 'returned-badge': item.checked, 'unretured-badge': item.checked === false }")
              span(v-if="item.checked") 已退藥
              span(v-else) 未退藥
            div.label-badge(v-if="item.event_type.event_name === 'FETCH' && item.checked && item.related_events.length > 0" :class="{ 'returned-badge': item.checked}")
              span(v-for="e in item.related_events") {{ e.event_type.event_name | zhLabel }} 
          
</template>

<script>
import moment from 'moment';
import { faNotesMedical, faCircle } from '@fortawesome/free-solid-svg-icons';
import Loader from '../common/Loader';

export default {
  name: 'EventTable',
  components: {
    Loader,
  },
  props: {
    eventType: {
      type: String,
    },
    device: {
      type: Number,
    },
    singleSelection: {
      type: Boolean,
      default: false,
    },
    number2: {
      type: Number, // this is used for schedule id
    },
    hideChecked: {
      type: Boolean,
      default: true,
    },
    noChecked: {
      type: Boolean,
      default: false,
    },
    returnEmpty: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      fetchStatus: 'start',
      searchText: '',
      queryData: undefined,
    };
  },
  methods: {
    selectEvent(id) {
      this.$store.dispatch('selectEvent', { eventId: id, singleSelection: this.singleSelection });
    },
  },
  async mounted() {
    const data = { event: this.eventType, drug_storage__isnull: false };
    if (this.device !== null) {
      data.device = this.device;
    }
    if (this.hideChecked) {
      data.checked = false;
    }
    if (this.number2) {
      data.number2 = this.number2;
      delete data.checked;
    }
    if (this.noChecked) {
      delete data.checked;
    }
    if (this.returnEmpty) {
      data.medication__return_when_empty = true;
    }

    data.system = this.$store.state.device.systemId;

    this.queryData = data;
    await this.$store.dispatch('getEvents', this.queryData);
    this.fetchStatus = 'done';
  },
  computed: {
    events() {
      return this.$store.state.event.events;
    },
    noteMedicalIcon() {
      return faNotesMedical;
    },
    circleIcon() {
      return faCircle;
    },
  },
  filters: {
    readableTime(value) {
      //20190510修改, 12小時改為24小時制
      //return moment(value).format('YYYY-MM-DD hh:mm');
      return moment(value).format('YYYY-MM-DD HH:mm');
    },
    zhLabel(value) {
      if (value === 'WASTE') return '已拋棄';
      if (value === 'RETURN_EMPTY') return '已退空瓶';
      if (value === 'RETURN') return '已退藥';
      return value;
    },
  },
  watch: {
    searchText(val) {
      this.$store.commit('FILTER_EVENTS', val);
    },
  },
};
</script>

<style lang="sass" scoped>
.info-col
  width: 100px

.returned-schedule
  pointer-events: none;
  box-shadow: none;
  border-style: unset
  color: rgba(0,0,0,0.3)


.drug-name
  display: flex

.drug-item
  position: relative
  align-items: center;
  display: flex;

.label-badge
  writing-mode: vertical-lr;
  color: white
  border-radius: 5px
  justify-content: center;
  align-items: center;
  display: inline-flex;
  margin-left: 0.25rem

.restrained-badge
  background-color: red

.unretured-badge
  background-color: yellow
  color: black

.returned-badge
  background-color: green
  color: white
   

</style>





// WEBPACK FOOTER //
// EventTable.vue?18000169